export default __webpack_public_path__ + "static/SVGTable01-6bc932b1e94c1685650f413a62c89d52.svg";